import i18n from '@/configuration/i18n/i18n.configuration';
import RouteNames from '@/configuration/router/names.routes';
import { ModulesEnum } from '@/core/modulesEnum';
import { IconName } from '@/models/icon-types';

export interface HomeTask {
  icon: IconName;
  title: string;
  description: string;
  disabled: boolean;
  routeName?: string;
}

export class TaskRegistry {
  private static t = i18n.global.t;

  static readonly tasks: Record<string, HomeTask> = {
    [ModulesEnum.LEGAL_ASSISTANT]: {
      icon: IconName.LegalAssistant,
      title: this.t('home.tasks.legal_assistant.title'),
      description: this.t('home.tasks.legal_assistant.description'),
      disabled: false,
      routeName: RouteNames.LegalAssistant
    },
    [ModulesEnum.DOC_REVIEWING]: {
      icon: IconName.DocReview,
      title: this.t('home.tasks.document_review.title'),
      description: this.t('home.tasks.document_review.description'),
      disabled: false,
      routeName: RouteNames.Reviewing
    },
    [ModulesEnum.LEGAL_MEMO]: {
      icon: IconName.LegalMemo,
      title: this.t('home.tasks.legal_memo.title'),
      description: this.t('home.tasks.legal_memo.description'),
      disabled: true // Todo: Change when implemented
    },
    [ModulesEnum.DOC_DRAFTING]: {
      icon: IconName.DocDrafting,
      title: this.t('home.tasks.document_drafting.title'),
      description: this.t('home.tasks.document_drafting.description'),
      disabled: true // Todo: Change when implemented
    }
  };
}
